import produce from 'immer'
// constant imports
import { COUNTRY_CODE_MAP } from 'constants/Countries'
import * as P from 'constants/Permissions'
import * as C from './constants'

const configReducer = (state = C.INITIAL_STATE, action) => {
  return produce(state, (draft) => {
    switch (action.type) {
      // ready
      case C.DIALER_READY:
        draft.ready = true
        break

      // account
      case C.ACCOUNT_FETCH_PENDING:
        draft.error = false
        draft.loading = true
        break
      case C.ACCOUNT_FETCH_FULFILLED:
        draft.account = action.payload
        draft.country = COUNTRY_CODE_MAP[action.payload.country]
        draft.error = false
        draft.loading = false
        break
      case C.ACCOUNT_FETCH_REJECTED:
        draft.account = action.payload
        draft.error = true
        draft.loading = false
        break

      // cnd
      case C.CND_FETCH_PENDING:
        draft.cnd.loading = true
        draft.cnd.error = false
        break
      case C.CND_FETCH_FULFILLED:
        draft.cnd.loaded = true
        draft.cnd.loading = false
        draft.cnd.name = action.payload.name
        draft.cnd.number = action.payload.number
        break
      case C.CND_FETCH_REJECTED:
        draft.cnd.loading = false
        draft.cnd.error = action.payload
        break

      // CALLER ID FETCHING
      case C.CALLER_ID_FETCH_PENDING:
        draft.callerIdsInfo.loading = true
        draft.callerIdsInfo.error = false
        break
      case C.CALLER_ID_FETCH_FULFILLED:
        draft.callerIdsInfo.loaded = true
        draft.callerIdsInfo.loading = false
        draft.callerIdsInfo.list = action.payload.lineData
        break
      case C.CALLER_ID_FETCH_REJECTED:
        draft.callerIdsInfo.loading = false
        draft.callerIdsInfo.error = action.payload
        break

      // CALLER ID UPDATING
      case C.CALLER_ID_UPDATE_PENDING:
        draft.callerIdsInfo.updating = true
        draft.callerIdsInfo.error = false
        break
      case C.CALLER_ID_UPDATE_FULFILLED:
        draft.callerIdsInfo.updating = false
        draft.callerIdsInfo.updated = true
        draft.callerIdsInfo.error = false
        break
      case C.CALLER_ID_UPDATE_REJECTED:
        draft.callerIdsInfo.updating = false
        draft.callerIdsInfo.updated = false
        draft.callerIdsInfo.error = true
        break

      // config
      case C.CONFIG_HYDRATE:
        Object.entries(action.payload).forEach(([k, v]) => {
          draft[k] = v
        })
        break

      // permissions
      case C.MICROPHONE_PERMISSION_FETCH_PENDING:
        draft.permissions.microphonePermissionLoading = true
        break
      case C.NOTIFICATIONS_PERMISSION_FETCH_PENDING:
        draft.permissions.notificationsPermissionLoading = true
        break
      case C.MICROPHONE_PERMISSION_FETCH_FULFILLED:
        draft.permissions[P.MICROPHONE] = action.payload
        draft.permissions.microphonePermissionLoading = false
        break
      case C.NOTIFICATIONS_PERMISSION_FETCH_FULFILLED:
        draft.permissions[P.NOTIFICATIONS] = action.payload
        draft.permissions.notificationsPermissionLoading = false
        break
      case C.PERMISSIONS_UPDATE:
        draft.permissions[action.payload.name] = action.payload.state
        break

      // language
      case C.LANGUAGE_UPDATE_FULFILLED:
        draft.language = action.payload
        break

      case C.TOKEN_TYPE_UPDATE:
        draft.tokenType = action.payload
        break

      // debug
      case C.DEBUG_FETCH:
      case C.DEBUG_UPDATE:
        draft.debug = { ...draft.debug, ...action.payload }
        break
      case C.DEBUG_CLEAR:
        draft.debug = false
        break
      case C.DEBUG_TOGGLE:
        if (!draft.debug) {
          draft.debug = { enable: true }
        } else {
          draft.debug.enable = !draft.debug.enable
        }
        break
      case C.SET_IS_SHOWN:
        draft.isShown = action.payload
        break
      case C.MODE_SET:
        draft.modeFloat = action.payload
        if (!action.payload) {
          draft.position = false
        }
        break
      case C.POSITION_SET:
        draft.position = action.payload
        break
      // TODO SPOG remove when dialer version 2 will be ready
      case C.CONSUMER_SET:
        draft.consumer = action.payload
        break
      // TODO SPOG remove when dialer version 2 will be ready
      case C.SIZE_SET:
        draft.size = action.payload
        break
      case C.SIZE_MODE_SET:
        draft.fullSize = action.payload
        break
      case C.SCALABLE_SET:
        draft.isScalable = action.payload
        break
      case C.ADD_SIP_ACTION:
        draft.sipActions.push(action.payload)
        break
      case C.REMOVE_SIP_ACTION:
        draft.sipActions = draft.sipActions.filter((a) => a !== action.payload)
        break
      case C.REMOVE_ALL_SIP_ACTIONS:
        draft.sipActions = []
        break

      default:
        break
    }
  })
}

export default configReducer
